import { ProductWizardNode, ProductWizardType, WizardOptions } from '../types'

export enum ProductWizardProcoteSteps {
  ChooseCrop = 'wizard_choose_crop',
  YieldAndPounds = 'wizard_enter_yield_and_pounds',
  Result = 'wizard_result',
  ChooseItem = 'wizard_choose_item',
}

export enum ProcoteStepNameForAnalytics {
  EntryQuestion = 'Entry question',
  ChooseCrop = 'Choose crop',
  ChooseProcote = 'Choose Procote',
  EnterPounds = 'Enter pounds',
  Result = 'Result',
  CloseQuestion = 'Close question',
  Unknown = 'Unknown',
}

export type ProcoteQuestionnaireType = {
  [key: string]: boolean
}

export type ProcoteParamsType<IsSku extends boolean = any> = {
  expected_yield_unit: string
  litres_per_tonne: number
  category_name: string | null
  fertilizer: number
  expected_yield: number
  acres: number
  has_purchased_fertilizer: boolean
} & (IsSku extends true
  ? {
      card_id: string
      sku_id: string
      card_title: string
    }
  : IsSku extends false
  ? {
      product_id: string
      product_name: string
    }
  : {
      card_id?: string | null
      sku_id?: string | null
      card_title?: string | null
      product_id?: string | null
      product_name?: string | null
    })

export type ProcoteWizardOptions = WizardOptions & {
  type: ProductWizardType.Procote
  unit_name: string | null
  category_id: string | null
  multiplier: number | null
  min: number | null
  max: number | null
  targeting_min: number | null
  description: string | null
  product_id: string | null
  sku_id: string | null
  card_id: string | null
}

export type ProcoteWizardNode = ProductWizardNode<ProductWizardType.Procote>
